import { render, staticRenderFns } from "./BadgePage.vue?vue&type=template&id=2ebf1e5a&scoped=true&"
import script from "./BadgePage.vue?vue&type=script&lang=js&"
export * from "./BadgePage.vue?vue&type=script&lang=js&"
import style0 from "./BadgePage.vue?vue&type=style&index=0&id=2ebf1e5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebf1e5a",
  null
  
)

export default component.exports